




















































import Vue, { PropType } from 'vue';

import { ALForm } from '@/common/component.types';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentStatus,
  InventoryAdvancePaymentStatusEnum
} from '@/models';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export interface ResolvedTransitionCommentDialog {
  isConfirmed: boolean;
  comment: string;
}

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'InventoryAdvancePaymentStateTransitionCommentFormDialog',

  components: {
    ConfirmationDialog
  },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    }
  },

  data() {
    return {
      resolve: (null as unknown) as (
        value:
          | ResolvedTransitionCommentDialog
          | PromiseLike<ResolvedTransitionCommentDialog>
      ) => void,

      valid: false,
      actionToState: -1,
      inventoryAdvancePaymentComment: '',
      commentsInventoryAdvancePaymentDialog: false,
      requiredRules: [(v: string) => !!v || 'This field is required']
    };
  },

  computed: {
    commentMandatory(): boolean {
      return (
        (this.actionToState == InventoryAdvancePaymentStatusEnum.Cancelled ||
          this.actionToState == InventoryAdvancePaymentStatusEnum.Rejected) &&
        !(
          this.inventoryAdvancePayment.status!.value ==
            InventoryAdvancePaymentStatusEnum.Submitted ||
          this.inventoryAdvancePayment.status!.value! ==
            InventoryAdvancePaymentStatusEnum.Draft
        )
      );
    },

    InventoryAdvancePaymentStatus: () => InventoryAdvancePaymentStatus
  },
  methods: {
    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    /**
     * @summary Await this dialog to close before continuing into the next action.
     */
    openCommentsDialog(toState: InventoryAdvancePaymentStatusEnum) {
      this.actionToState = toState;
      this.inventoryAdvancePaymentComment = '';
      this.commentsInventoryAdvancePaymentDialog = true;

      return new Promise<ResolvedTransitionCommentDialog>(resolve => {
        this.resolve = resolve;
      });
    },

    agreeCommentsDialog() {
      if (this.validateForm()) {
        this.commentsInventoryAdvancePaymentDialog = false;
        return this.resolve({
          isConfirmed: true,
          comment: this.inventoryAdvancePaymentComment
        });
      }
    },

    cancelCommentsDialog() {
      this.commentsInventoryAdvancePaymentDialog = false;
      return this.resolve({
        isConfirmed: false,
        comment: ''
      });
    }
  }
});
